import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Text,
} from '@chakra-ui/react';
import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';

import { Channel, CHANNELS } from 'types/customer';
import { ChannelFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  watchChannel: Channel;
  error: FieldError | undefined;
};

/**
 * 新規登録モーダル用の契約種別フォームです。
 */
export const ChannelForm: FC<Props> = ({ register, watchChannel, error }) => (
  <FormControl isRequired isInvalid={Boolean(error)}>
    <FormLabel>契約種別</FormLabel>
    <ChannelFormBase register={register} />
    {watchChannel === CHANNELS.BETA && (
      <Box mt="10px" ml="10px">
        <Text color="red">※ β版には不具合が含まれる場合があります。</Text>
      </Box>
    )}
    <FormErrorMessage>{error && error.message}</FormErrorMessage>
  </FormControl>
);
